import * as React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import {
  getWidgetProps,
  WPSClient,
  Args,
  withArgs,
  Widget
} from 'DVWebNodeUtils'

import { requestWpsData } from '../../utils/requestWpsData'
import { StringBundle } from '../../components/localizer/localizer'
import { configureStore } from '../../store'
import {
  normalizeGetDetailPage, NormalizeGetDetailPageType,
  normalizeGetStrings, NormalizeGetStringsType
} from '../../data/normalize'
import { IDetailPageState } from '../../reducers'
import { getAdditionalInput } from '../../data/getDetailPageInputs'
import { safeBoolean } from '../../utils/utils'
import { ErrorBoundary } from '../../components/error/ErrorBoundary'
import { AdditionalComponent } from './component'

export interface AdditionalProps {
  state:
    NormalizeGetDetailPageType &
    NormalizeGetStringsType &
    Pick<IDetailPageState, 'features'>
}

export const getProps: getWidgetProps<AdditionalProps> = async ({ context, titleID, useFaq, useContactUs,
  usePlayer, useNewHover, useNodeDeeplinking }, api) => {
  const operation = (wpsClient: WPSClient) =>
      wpsClient.GetDetailPage(getAdditionalInput({ context, titleID }, safeBoolean(useFaq), safeBoolean(useContactUs)))

  const reply = await requestWpsData({
    context,
    api,
    operation,
    stringBundle: StringBundle.BTF
  })

  const features = {
    useFaq: safeBoolean(useFaq),
    useContactUs: safeBoolean(useContactUs),
    usePlayer: safeBoolean(usePlayer),
    useNewHover: safeBoolean(useNewHover),
    useNodeDeeplinking: safeBoolean(useNodeDeeplinking)
  }

  return {
    state: {
      features,
      ...normalizeGetDetailPage(titleID, reply.operationResponse),
      ...normalizeGetStrings(reply.stringsResponse!)
    },
  }
}

const AdditionalWidget = (props: AdditionalProps & Args) => {
  const { logger, state, context: requestContext } = props
  const store = configureStore({ ...state, requestContext }, logger)

  return (
    <ReduxProvider store={store}>
      <ErrorBoundary name="additional">
        <AdditionalComponent/>
      </ErrorBoundary>
    </ReduxProvider>
  )
}

export const Additional: Widget<AdditionalProps> = {
  name: 'detail-additional',
  getProps: global.__SERVER__ === true ? getProps : undefined,
  Component: withArgs(AdditionalWidget) as React.ComponentType<any>
}
